module.exports = __webpack_public_path__ + "img/2.cb8f2e6e.webp";